import Model from "../Model";

class Comercialclientidtops extends Model{

    buildUrl ({ param }) {
        return ['/zoneclientview/topuserid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Comercialclientidtops;